module.exports = __webpack_public_path__ + "img/caution.df3283b0.svg";